import "./sellscreendialogs.scss";
import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type RootState } from "../../../Reducers/ShopfrontReducers";
import { withPortal } from "../../../Utilities/UI/PortalHelper";

const mapStateToProps = (state: RootState): {
    hasDialog: boolean;
} => ({
    hasDialog: state.dialog.visible && !state.dialog.showFrame,
});

const connector = connect(mapStateToProps);

export class FocusLost extends React.Component<ConnectedProps<typeof connector>> {
    public onClick = (e: React.MouseEvent<HTMLDivElement>): void => {
        e.stopPropagation();
    };

    public render(): React.ReactNode {
        if(this.props.hasDialog) {
            return null;
        }

        return (
            <div
                className="focus-lost"
                onClick={this.onClick}
            >
                <div>Focus has been lost</div>
                <div>Click here to regain focus</div>
            </div>
        );
    }
}

export default connector(withPortal("#focus", FocusLost));
